import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { KnownDeliveryDtoState, KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutationMarkDeliveryCancel } from '../../deliveries-details.queries';
import { useWaitForUpdate } from '../../hooks/use-wait-for-update.hook';
import { Delivery } from '../../../models/delivery.model';

export function MarkCancelledModal({
  delivery,
  onAbort,
  onFailed,
  onSuccess
}: {
  delivery: Delivery;
  onAbort(): void;
  onFailed(): void;
  onSuccess(): void;
}) {
  const onSuccessHandler = useWaitForUpdate({
    maximumWaitTime: 1000 * 10,
    onFailed,
    onSuccess,
    predicate: () => delivery.state === KnownDeliveryState.Cancelled
  });

  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationMarkDeliveryCancel,
    mutationArgs: { deliveryID: delivery.id },
    onSuccess: onSuccessHandler
  });

  return (
    <ConfirmationModal
      title="Mark Cancelled?"
      content={makeModalContent(delivery.state)}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Mark Cancelled',
        color: 'danger'
      }}
      cancelButton={{
        label: 'No'
      }}
      {...state}
    />
  );
}

function makeModalContent(status: string): string[] {
  const content = [
    `Marking the delivery Cancelled is for when it was made in error or the locker was accidentally empty.`
  ];

  if (assertIsIntermediateState(status)) {
    content[0] += ` We'll update the locker state to reflect that it is now empty and the recipient's collection code will no longer work.`;
    content.push(
      `If the delivery has been taken out of the locker and given to the recipient instead mark it Collected or, if given back to the sender, mark as Retrieved.`
    );
  }

  content.push(`Are you sure?`);

  return content;
}

function assertIsIntermediateState(status: string) {
  return [
    KnownDeliveryDtoState.Delivered,
    KnownDeliveryDtoState.Overdue,
    KnownDeliveryDtoState.RetrievalRequired
  ].includes(status as KnownDeliveryDtoState);
}
